import * as Sentry from "@sentry/react";

import type { AuthenticationDetails, InitOptions } from "./types";
import { addLogSubscriber } from "../logger";

export const sentryAttachAuth = (details: AuthenticationDetails) => {
  Sentry.setUser({
    id: details.user.id,
    username: `${details.user.given_name} ${details.user.family_name}`,
    email: details.user.email,
  });
};

export const sentryInit = (_p: InitOptions, router?: unknown) => {
  Sentry.init({
    dsn: "https://fe87329662ff690016184c6cb335abb1@o4505007010414592.ingest.us.sentry.io/4506944634224640",
    integrations: [
      Sentry.browserProfilingIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.httpClientIntegration(),
      ...(router ? [Sentry.tanstackRouterBrowserTracingIntegration(router)] : []),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    profilesSampleRate: 1.0,

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost"],
  });

  Sentry.init({
    dsn: "https://fe87329662ff690016184c6cb335abb1@o4505007010414592.ingest.us.sentry.io/4506944634224640",
    integrations: [Sentry.browserProfilingIntegration(), Sentry.browserTracingIntegration()],
  });

  addLogSubscriber({
    onEvent: (e) => {
      if (e.level !== "error") return;
      Sentry.captureException(e.error ?? e.message, e.fields);
    },
  });
};
